export const ACCOUNT_USER_LIST_QUERY_KEYS = {
  LIST: ['account', 'user', 'list'],
  REQUEST_DOWNLOAD_EXCEL: ['account', 'user', 'list', 'download', 'excel'],
};
